<template>
  <div>&nbsp;</div>
</template>

<script>
export default {
  name: "interpage",
  data() {},
  created() {
    let url = window.location.href.split("/#/")[0];
    console.log(url, "域名");
    window.location.href = `${url}/prsite/index.html`;
    // window.location.href = "https://pr.joyousoa.com/prsite/index.html";
    // window.location.href = "http://salary.prosuntech.com/prsite/index.html";
  },
  methods: {},
};
</script>
